// Email automation types based on swagger.json API specification

export type EmailAutomationTrigger =
  | "pre_approved"
  | "closed_conditions"
  | "approaching_approval_expiration_date";

export interface EmailAutomationRule {
  id: string;
  trigger: EmailAutomationTrigger;
  delay_hours: number;
  is_active: boolean;
  created_at: string;
  created_by: string;
  updated_at?: string;
}

export interface CreateEmailAutomationRuleRequest {
  trigger: EmailAutomationTrigger;
  delay_hours?: number; // 0-72 hours, defaults to 0 for immediate
}

export interface ListEmailAutomationRulesResponse {
  rules: EmailAutomationRule[];
}

const emailAutomationTriggerLabels: Record<EmailAutomationTrigger, string> = {
  pre_approved: "Pre-Approved",
  closed_conditions: "Closed Conditions",
  approaching_approval_expiration_date: "Approaching Approval Expiration Date",
};

export const formatEmailAutomationTrigger = (
  trigger: string | undefined,
): string => {
  if (!trigger) return "";

  const upperTrigger = trigger as EmailAutomationTrigger;
  return emailAutomationTriggerLabels[upperTrigger] || trigger;
};

export const getEmailAutomationTriggerOptions = () => {
  return Object.entries(emailAutomationTriggerLabels).map(([value, label]) => ({
    value,
    label,
  }));
};
